<!--备份血样（可选）-->
<script setup>
import { computed, onActivated, onBeforeUpdate, onUpdated, reactive } from "vue";

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  if (model.fields[props.type] && model.fields[props.type]["备份血样"] === undefined) {
    model.fields[props.type]["备份血样"] = "未知";
  }
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display: flex;">
      <h2 id="备份血样（可选）">备份血样（可选）</h2>
      <p class="title_p">共留取三管血：黄帽管血2管（惰性胶分离促凝管，每管5ml），紫帽管血1管（EDTA抗凝，10ml），800-1000g 离心留取血清和外周血PBMC，超低温冰箱-80°C保存；促凝管留取的血清，建议分4个冻存管保存，每管至少100ul。</p>
    </div>
    <p class="bfxy">备份血样:根据本研究的次要研究目的，需探索可能的 PSVD 早期诊断及预后评价的血清标志物，目前暂无文献报道相关指标，
      我们后续将根据研究结果 拟定血清标志物(如 miRNA 等)，因此需在基线时间点，各中心自行保存血样在有资质备案的生物样本库，以备后续可能的血清标志物检测。该部分血 样留取将请患者签署知情同意书。</p>
    <el-form-item label="备份血样（可选）" >
      <el-radio-group v-model="crfFields['备份血样']">
        <el-radio label="已备份" prop="已备份"></el-radio>
        <el-radio label="未备份" prop="未备份"></el-radio>
        <!-- <el-radio label="未知" prop="未知"></el-radio> -->
      </el-radio-group>
    </el-form-item>
    <p class="illustrate">或在随访期留⼀次⾎样</p>
  </template>
</template>

<style scoped>
.title_p{
  margin-top: 20px;
  max-width: 500px;
  font-size: 13px;
  color: black;
}
.bfxy{
  padding-left: 20px;
  width: 600px;
  font-size: 13px;
  color: black;
}
.illustrate{
  margin: 0;
  font-size: 12px;
}
</style>